import type { SVGProps } from "react";
const SvgLuggageNotSelected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#luggageNotSelected_svg__a)">
      <path
        fill="#868686"
        d="M16.157 5.295h-1.312l-.033-.693c0-.241.196-.437.437-.437h.437c.241 0 .437.196.437.437zm-6.935 0h-1.31l-.034-.693c0-.241.196-.437.437-.437h.437c.241 0 .437.196.437.437z"
      />
      <g filter="url(#luggageNotSelected_svg__b)" opacity={0.5}>
        <ellipse cx={11.997} cy={22.029} fill="#000" rx={5.867} ry={0.231} />
      </g>
      <path
        fill="url(#luggageNotSelected_svg__c)"
        d="M8.25 22.03a.937.937 0 1 0 0-1.876.937.937 0 0 0 0 1.875"
      />
      <path
        fill="url(#luggageNotSelected_svg__d)"
        d="M15.75 22.03a.937.937 0 1 0 0-1.876.937.937 0 0 0 0 1.875"
      />
      <path
        fill="url(#luggageNotSelected_svg__e)"
        d="M15.75 20.154c.517 0 .937.42.937.938h-1.875c0-.518.42-.938.938-.938"
      />
      <path
        fill="url(#luggageNotSelected_svg__f)"
        d="M8.25 20.154c.517 0 .937.42.937.938H7.312c0-.518.42-.938.938-.938"
      />
      <path
        fill="url(#luggageNotSelected_svg__g)"
        d="M13.407 2.677h-2.813v2.506h-.937V2.677c0-.548.42-.991.937-.992h2.813c.517 0 .937.444.938.992v2.506h-.938z"
      />
      <foreignObject width={12.875} height={18.394} x={5.561} y={3.604}>
        <div
          style={{
            backdropFilter: "blur(.5px)",
            clipPath: "url(#luggageNotSelected_svg__h)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>
      <path
        fill="url(#luggageNotSelected_svg__i)"
        d="M16.03 4.604H7.966c-.777 0-1.406.63-1.406 1.406v13.58c0 .777.63 1.406 1.406 1.406h8.062c.777 0 1.407-.63 1.407-1.406V6.01c0-.777-.63-1.406-1.407-1.406"
        data-figma-bg-blur-radius={1}
      />
      <path
        fill="url(#luggageNotSelected_svg__j)"
        d="M11.678 10.368s-.234-.016-.367-.136l.123-2.143h.466s.163.002.277-.036c.114-.039.325-.025.325-.025l.136.025h1.094l.53-.025.08.019c.045.14.226.66.226.66l.065 1.793h-.262l-.281.068-1.685-.125s-.105.02-.242.02-.318-.05-.318-.05l.055.021a2 2 0 0 0-.222-.066"
      />
      <path
        fill="#fff"
        d="M10.477 6.896a.234.234 0 0 0-.234.234v12.089a.234.234 0 0 0 .468 0V7.13a.234.234 0 0 0-.234-.234m-1.522 0a.234.234 0 0 0-.235.234v12.089a.234.234 0 0 0 .469 0V7.13a.234.234 0 0 0-.234-.234m3.047 0a.234.234 0 0 0-.234.234v12.089a.234.234 0 0 0 .468 0V7.13a.234.234 0 0 0-.234-.234m1.522 0a.234.234 0 0 0-.234.234v12.089a.234.234 0 0 0 .469 0V7.13a.234.234 0 0 0-.235-.234m1.522 0a.234.234 0 0 0-.234.234v12.089a.234.234 0 0 0 .469 0V7.13a.234.234 0 0 0-.235-.234"
        opacity={0.4}
      />
      <path
        fill="#272727"
        d="m14.344 2.666-4.69.018c0-.518.42-1 .937-1h2.813c.518 0 .94.464.94.982"
        opacity={0.4}
      />
    </g>
    <defs>
      <linearGradient
        id="luggageNotSelected_svg__e"
        x1={15.749}
        x2={15.749}
        y1={20.628}
        y2={21.026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="luggageNotSelected_svg__f"
        x1={8.25}
        x2={8.25}
        y1={20.628}
        y2={21.026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="luggageNotSelected_svg__g"
        x1={8.159}
        x2={12.847}
        y1={5.684}
        y2={5.684}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#c2c2c2" stopOpacity={0.9} />
        <stop offset={1} stopColor="#a7a7a7" stopOpacity={0.9} />
      </linearGradient>
      <linearGradient
        id="luggageNotSelected_svg__i"
        x1={11.998}
        x2={11.998}
        y1={8.354}
        y2={21.402}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#acacac" stopOpacity={0.5} />
        <stop offset={1} stopColor="#a9a9a9" />
      </linearGradient>
      <linearGradient
        id="luggageNotSelected_svg__j"
        x1={11.291}
        x2={15.721}
        y1={9.186}
        y2={9.186}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.102} stopColor="#fff" />
        <stop offset={0.115} stopColor="#e3e3e3" />
        <stop offset={0.204} stopColor="#fff" />
        <stop offset={0.214} stopColor="#e3e3e3" />
        <stop offset={0.233} stopColor="#e3e3e3" />
        <stop offset={0.446} stopColor="#fff" stopOpacity={0.973} />
        <stop offset={0.455} stopColor="#e3e3e3" />
        <stop offset={0.549} stopColor="#fff" />
        <stop offset={0.56} stopColor="#e3e3e3" />
        <stop offset={1} stopColor="#e3e3e3" />
      </linearGradient>
      <radialGradient
        id="luggageNotSelected_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(8.25 21.092)scale(.9375)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1f1f1f" />
        <stop offset={0.462} stopColor="#4d4d4d" />
        <stop offset={0.759} stopColor="#4d4d4d" />
        <stop offset={0.829} stopColor="#3b3b3b" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <radialGradient
        id="luggageNotSelected_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(15.75 21.092)scale(.9375)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1f1f1f" />
        <stop offset={0.462} stopColor="#4d4d4d" />
        <stop offset={0.759} stopColor="#4d4d4d" />
        <stop offset={0.829} stopColor="#3b3b3b" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <clipPath
        id="luggageNotSelected_svg__h"
        transform="translate(-5.56 -3.604)"
      >
        <path d="M16.03 4.604H7.966c-.777 0-1.406.63-1.406 1.406v13.58c0 .777.63 1.406 1.406 1.406h8.062c.777 0 1.407-.63 1.407-1.406V6.01c0-.777-.63-1.406-1.407-1.406" />
      </clipPath>
      <clipPath id="luggageNotSelected_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <filter
        id="luggageNotSelected_svg__b"
        width={15.733}
        height={4.463}
        x={4.13}
        y={19.797}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_4326_16779"
          stdDeviation={1}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgLuggageNotSelected;
